<template>
  <div class="selection-group">
    <div
      style="position: absolute;
    bottom: -42px;
    right: 25%;
    margin-right: -25px;"
    >
      <v-btn @click.stop.native="$emit('makePage')">Group</v-btn>
      <v-btn @click.stop.native="$emit('gridSelectedRows')">Rows</v-btn>
      <v-btn @click.stop.native="$emit('gridSelectedCols')">Cols</v-btn>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.selection-group {
  position: absolute;
  border: 1px dashed #929292;
}
</style>
